import React from "react";
import { motion } from "framer-motion";

import heroIcon1 from "../Images/hero-icon-1.png";
import heroIcon2 from "../Images/hero-icon-2.png";
import heroIcon3 from "../Images/hero-icon-3.png";

const BreadcrumbMain = ({
  subTitle,
  title,
  description,
  image,
  showIcons = true,
  extraText = "",
  specialNote = "",
}) => {

  // PREMIUM STAGGER
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.16,
      },
    },
  };

  // FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.95,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // FEATURE CARD
  const featureVariant = {
    hidden: {
      opacity: 0,
      y: 35,
      scale: 0.96,
    },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.8,
        delay: i * 0.12,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="breadcrumb-main">

        <motion.div
          className="container breadcrumb-main-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.15,
          }}
        >

          {/* LEFT CONTENT */}

          <motion.div
            className="breadcrumb-main-left"
            variants={containerVariants}
          >

            {subTitle && (

              <motion.p
                className="hero-subtitle"
                variants={fadeUp}
              >
                {subTitle}
              </motion.p>

            )}

            <motion.h1
              className="hero-title"
              variants={fadeUp}
            >
              {title}
            </motion.h1>

            {/* SPECIAL NOTE */}

{specialNote && (

  <motion.div
    className="special-text"
    variants={fadeUp}
  >

    <span>
      {specialNote}
    </span>

  </motion.div>

)}

            <motion.p
              className="section-text"
              variants={fadeUp}
            >
              {description}
            </motion.p>

            {/* CONDITIONAL BLOCK */}

            {showIcons ? (

              <motion.div
                className="hero-features"
                variants={fadeUp}
              >

                {/* FEATURE 1 */}

                <motion.div
                  className="hero-feature"
                  custom={0}
                  variants={featureVariant}
                  whileHover={{
                    y: -6,
                  }}
                  transition={{
                    duration: 0.35,
                  }}
                >

                  <motion.img
                    src={heroIcon1}
                    alt="Secure Transactions | LDL Settlement Services"
                    whileHover={{
                      scale: 1.08,
                      rotate: -2,
                    }}
                    transition={{
                      duration: 0.35,
                    }}
                  />

                  <span>
                    Secure <br />
                    Transactions
                  </span>

                </motion.div>

                {/* FEATURE 2 */}

                <motion.div
                  className="hero-feature"
                  custom={1}
                  variants={featureVariant}
                  whileHover={{
                    y: -6,
                  }}
                  transition={{
                    duration: 0.35,
                  }}
                >

                  <motion.img
                    src={heroIcon2}
                    alt="Experienced Professionals | LDL Settlement Services"
                    whileHover={{
                      scale: 1.08,
                      rotate: -2,
                    }}
                    transition={{
                      duration: 0.35,
                    }}
                  />

                  <span>
                    Experienced <br />
                    Professionals
                  </span>

                </motion.div>

                {/* FEATURE 3 */}

                <motion.div
                  className="hero-feature no-border"
                  custom={2}
                  variants={featureVariant}
                  whileHover={{
                    y: -6,
                  }}
                  transition={{
                    duration: 0.35,
                  }}
                >

                  <motion.img
                    src={heroIcon3}
                    alt="Efficient Settlements | LDL Settlement Services"
                    whileHover={{
                      scale: 1.08,
                      rotate: -2,
                    }}
                    transition={{
                      duration: 0.35,
                    }}
                  />

                  <span>
                    Efficient <br />
                    Settlements
                  </span>

                </motion.div>

              </motion.div>

            ) : (

              extraText && (

                <motion.p
                  className="section-text"
                  variants={fadeUp}
                >
                  {extraText}
                </motion.p>

              )

            )}

          </motion.div>

          {/* RIGHT IMAGE */}

          <motion.div
            className="breadcrumb-main-right"
            initial={{
              opacity: 0,
              x: 70,
              scale: 0.96,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
              scale: 1,
            }}
            transition={{
              duration: 1.1,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
          >

            <motion.img
              src={image}
              alt={`${title} | LDL Settlement Services`}
              whileHover={{
                scale: 1.03,
              }}
              transition={{
                duration: 0.5,
                ease: [0.22, 1, 0.36, 1],
              }}
            />

          </motion.div>

        </motion.div>

      </section>
    </>
  );
};

export default BreadcrumbMain;